module.exports = __webpack_public_path__ + "static/media/SoloPic.ea661f80.png";